import styled, { css } from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'

const CenterEnabled = css`
    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}
`

const H1 = styled.h1`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: 300;
    font-size: 38px;
    line-height: 44px;    
    margin: 0;
    color: ${Variables.color.pazola};

    ${media('<desktop')} {
        font-size: 24px;
        line-height: 30px;
    }

    ${CenterEnabled}
`

const H0 = styled(H1)`
    font-size: 60px;
    line-height: 78px; 
    letter-spacing: 0.0025em;

    ${media('>=desktop')} {
        font-size: 58px;
        letter-spacing: -0.005em;
    }

    ${media('<desktop')} {
        font-size: 38px;
        line-height: 120%;
    }
`

const H2 = styled.h2`
    font-style: normal;    
    color: ${Variables.color.pazola};
    font-family: ${Variables.font.title};
    font-weight: normal;
    font-size: 38px;
    line-height: 44px;
    margin: 0;
    ${CenterEnabled}

    ${media('<desktop')} {
        font-size: 24px;
        line-height: 30px;
    }
`

const H3 = styled.h3`
    font-family: ${Variables.font.body};
    font-weight: 300;
    font-size: 36px;
    line-height: 47px;
    margin: 0;
    color: ${Variables.color.pazola};
    ${CenterEnabled}

    ${media('<desktop')} {
        font-size: 24px;
        line-height: 30px;
    }
`

const H4 = styled.h4`
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: normal;
    font-size: 34px;
    line-height: 135%;
    letter-spacing: 0.0025em;
    margin: 0;
    ${CenterEnabled}
`

const H5 = styled.h5`
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 120%;
    letter-spacing: 0.0025em;
    margin: 0;
    
    ${media('<desktop')} {
        font-size: 20px;
        letter-spacing: 0.0015em;
    }

    ${CenterEnabled}
`

const H6 = styled.h6`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: 0.0015em;
    margin: 0;
    ${CenterEnabled}
`

const Overline = styled.div`
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    letter-spacing: 0.0015em;

    ${CenterEnabled}
`

const BodyCopy = styled.div`    
    line-height: 26px;
    color: ${Variables.color.pazola};

    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.005em;

    p {
        margin: 1.6em 0;
        white-space: pre-wrap;
        word-wrap: normal;
        resize: none;
        box-sizing: border-box;
        :first-child {
            margin-top: 0;
        }
        :last-child {
            margin-bottom: 0;
        }
    }

    ul {
        list-style: none;
        margin: -5px 0;
        padding: 0;
        display: flex;
        flex-direction: column;

        li {
            position: relative;
            display: flex;
            margin: 5px 0;
            :before {
                content: '- ';
            }
        }
    }

    blockquote {
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 300;
        font-size: 32px;
        line-height: 37px;
        color: ${Variables.color.pazola};
        margin: 0;
        display: flex;

        p {
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 300;
            font-size: 32px;
            line-height: 37px;
            color: ${Variables.color.pazola};
            margin: 0;
            display: flex;
            width: 100%;
        }
    }

    h6 {
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        font-family: ${Variables.font.body};
        font-style: normal;    
        margin: 0;

        ${media('<desktop')} {
            font-size: 16px;
            line-height: 20px;
        }
        + p {
            margin-top: 13px;
        }
    }

    h5 {
        font-size: 14px;
        font-weight: normal;
    }

    ${CenterEnabled}
`

export { H0, H1, H2, H3, H4, H5, H6, Overline, BodyCopy }
